<template>
	<el-container direction="vertical">
		<div class="colhead">
			<h2 class="header_h2">用户信息管理</h2>
		</div>
		<el-header>
			<el-button type="primary" style="margin:10px 5px 0px 10px;float: left;" @click="baonewAdd">新增</el-button>
			<el-input v-model="select_word" placeholder="用户名过滤查找" style="display:inline-block;width:350px;float: left;">
			</el-input>

		</el-header>

		<el-main>

			<el-table border ref="multipleTable" tooltip-effect="dark"
				:data="data.slice((currentPage-1)*pagesize,currentPage*pagesize)">

				<el-table-column prop="isvalid" label="启用">
					<template slot-scope="scope">
						<label v-if='scope.row.isvalid=="0"'>禁用</label>
						<label v-if='scope.row.isvalid=="1"'>启用</label>
					</template>
				</el-table-column>
				<el-table-column prop="username" label="用户名" width="120px"></el-table-column>
				<el-table-column prop="roleid" label="角色">
					<template slot-scope="scope">
						<div v-for="item in rolelist">
							<label v-if='scope.row.roleid==item.roleid'>{{item.rolename}}</label>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="corpid" label="所属单位">
					<template slot-scope="scope">
						<div v-for="item in CorpData">
							<label v-if='scope.row.corpid==item.corp_id'>{{item.corp_name}}</label>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="discription" label="备注" width="220px"></el-table-column>
				<el-table-column prop="empname" label="操作员" width="100px"></el-table-column>
				<el-table-column prop="empdate" label="操作时间" width="120px"></el-table-column>
				<el-table-column label="操作" width="100px">
					<template slot-scope="scope">
						<el-button @click="handleEdit(scope.$index, scope.row)" icon="el-icon-edit" type="text"
							size="small">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-footer style="margin-top:20px;">
				<template>
					<div class="block">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page="currentPage" :page-sizes="[5, 10, 20, 40]" :page-size="pagesize"
							layout="total, sizes, prev, pager, next, jumper" :total="data.length"></el-pagination>
					</div>
				</template>
			</el-footer>
		</el-main>
		<!-- 修改个人信息 -->
		<el-dialog title="修改信息" :visible.sync="bao1edit">
			<el-form :model="EditInfo" ref="EditInfo">
				<el-form-item label="启用">
					<el-checkbox v-model="editchk"></el-checkbox>
				</el-form-item>
				<el-form-item label="账号">
					<el-input style="display:inline-block;width:80%;" v-model="EditInfo.username" placeholder="请输入用户名">
					</el-input>
				</el-form-item>
				<el-form-item label="角色">
					<el-select v-model="EditInfo.roleid" placeholder="请选择角色" style="width: 200px;">
						<el-option v-for="item in rolelist" :label="item.rolename" :value="item.roleid">
							{{ item.rolename }}
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="所属单位">
					<el-select style=" width: 200px;  height:30px;" placeholder="请选择" v-model="EditInfo.corpid">
						<el-option v-for="item in CorpData" :label="item.corp_name" :value="item.corp_id">
							{{ item.corp_name }}
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="备注">
					<el-input style="display:inline-block;width:80%;" v-model="EditInfo.discription"></el-input>
				</el-form-item>

			</el-form>
			<!-- 按钮确定和取消 -->
			<span slot="footer">
				<el-button type="primary" @click.native="bao1editSure">确定</el-button>
				<el-button @click.native="bao1edit = false">取消</el-button>
			</span>
		</el-dialog>

		<!-- ----新增个人信息---- -->
		<el-dialog title="新增用户信息" :visible.sync="bao1newadd">
			<el-form :model="AddInfo" ref="AddInfo">
				<el-form-item label="启用">
					<el-checkbox v-model="addchk"></el-checkbox>
				</el-form-item>
				<el-form-item label="账号">
					<el-input style="display:inline-block;width:80%;" v-model="AddInfo.username" placeholder="请输入用户名">
					</el-input>
				</el-form-item>
				<el-form-item label="密码">
					<el-input type="password" style="display:inline-block;width:80%;" v-model="AddInfo.userpwd"
						placeholder="请输入密码"></el-input>
				</el-form-item>
				<el-form-item label="角色">
					<el-select v-model="AddInfo.roleid" placeholder="请选择角色" style="width: 200px;">
						<el-option v-for="item in rolelist" :label="item.rolename" :value="item.roleid">
							{{ item.rolename }}
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="所属单位">
					<el-select style=" width: 200px;  height:30px;" placeholder="请选择" v-model="AddInfo.corpid">
						<el-option v-for="item in CorpData" :label="item.corp_name" :value="item.corp_id">
							{{ item.corp_name }}
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="备注">
					<el-input style="display:inline-block;width:80%;" v-model="AddInfo.discription"></el-input>
				</el-form-item>
			</el-form>
			<!-- 按钮确定和取消 -->
			<span slot="footer">
				<el-button type="primary" @click.native="bao1AddSure">确定</el-button>
				<el-button @click.native="bao1newadd = false">取消</el-button>
			</span>
		</el-dialog>
	</el-container>
</template>



<script>
	import user from '../apifunction/User.js'
	import role from '../apifunction/Role.js'
	import commfun from '../commontools/CommonFun.js'
	import corp from '../apifunction/Corp.js'
	export default {
		data() {
			return {
				userlist: [],
				rolelist: [],
				CorpData: [],
				currentPage: 1,
				pagesize: 10,
				bao1edit: false,
				bao1newadd: false,
				editchk: true,
				addchk: true,
				idx: null,
				//   通过姓名查询
				select_word: "",
				//   定义初始个人信息
				EditInfo: {
					id: '',
					username: '',
					userpwd: '',
					roleid: '',
					empname: '',
					empdate: '',
					discription: '',
					isvalid: '1',
					corpid: ''
				},
				AddInfo: {
					id: '',
					username: '',
					userpwd: '',
					roleid: '',
					empname: '',
					empdate: '',
					discription: '',
					isvalid: '1',
					corpid: ''
				}
			};
		},
		mounted() {
			this.GetAllUser();
			this.GetAllRole();
			this.InitCorp();
		},
		methods: {
			InitCorp() {
				corp.GetAllCorp()
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.CorpData = JSON.parse(ent.Data);
						} else
							this.$message.info(ent.Msg);
					})
			},
			//   得到所有的数据---------------
			GetAllUser() {
				user.GetAllUser()
					.then(res => {
						var ent = JSON.parse(JSON.stringify(res.data));
						if (ent.Flag == 'success') {
							this.userlist = JSON.parse(ent.Data);
						}
					})
			},
			GetAllRole() {
				role.GetAllRole()
					.then(res => {
						var ent = JSON.parse(JSON.stringify(res.data));
						if (ent.Flag == 'success') {
							this.rolelist = JSON.parse(ent.Data);
						}
					})
			},
			// 分页------------------------
			// 初始页currentPage、初始每页数据数pagesize和数据data
			handleSizeChange: function(size) {
				this.pagesize = size;
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
			},
			// 操作界面 ----------- 编辑-----通过改变数据并且驱动视图更新$set方法
			handleEdit(index, row) {
				this.idx = index;
				this.bao1edit = true;
				this.EditInfo = {
					id: row.id,
					username: row.username,
					userpwd: '',
					roleid: row.roleid,
					empname: row.empname,
					empdate: row.empdate,
					discription: row.discription,
					isvalid: row.isvalid
				};
				this.editchk = row.isvalid == "1" ? true : false;
			},
			// 操作界面 ----------- 编辑 -------确定按钮
			bao1editSure() {
				this.EditInfo.isvalid = this.editchk ? "1" : "0";
				this.EditInfo.empname = this.$myglobal.username;
				this.EditInfo.empdate = commfun.GetNowDateTime();
				this.EditInfo.userpwd = commfun.EncryptMd5(this.EditInfo.userpwd)
				user.EditUser(this.EditInfo)
					.then(res => {
						var ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.data.splice(this.idx, 1, this.EditInfo)
							//this.$set(this.data, this.idx, this.EditInfo);
							this.bao1edit = false;
							this.$message.success("修改成功");
						} else
							this.$message.success(ent.Msg);
					})

			},
			// 新增按钮-----
			baonewAdd() {
				this.bao1newadd = true;
				this.addchk = true;
				this.AddInfo.username = "";
				this.AddInfo.id = "";
				this.AddInfo.userpwd = "";
				this.AddInfo.discription = "";
				this.AddInfo.isvalid = "1";
			},
			// 新增按钮----- 新增 ----确定按钮
			bao1AddSure() {
				if (this.AddInfo.username == '') {
					this.$message.info("用户账号不能为空！");
					return;
				}
				this.AddInfo.id = commfun.NewGuid();
				this.AddInfo.isvalid = this.addchk ? "1" : "0";
				this.AddInfo.empname = this.$myglobal.userinfo.username;
				this.AddInfo.empdate = commfun.GetNowDateTime();

				user.UserNameCanUse(this.AddInfo.username)
					.then(res => {
						var ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.AddInfo.userpwd = commfun.EncryptMd5(this.AddInfo.userpwd)
							user.AddUser(this.AddInfo)
								.then(res1 => {
									var ent1 = JSON.parse(JSON.stringify(res1.data))
									if (ent1.Flag == 'success') {
										this.AddInfo.id = ent1.data;
										// if(this.data.length>=this.currentPage*this.pagesize)
										// this.data.pop();
										this.data.unshift(this.AddInfo);
										this.bao1newadd = false;
										this.currentPage = 1;
										this.$message.success("新增成功");
									} else
										this.$message.info(ent1.Msg);
								})
						} else
							this.$message.info(ent.Msg);
					})
			}
		},
		computed: {
			data() {
				return this.userlist.filter(item => {
					if (this.select_word == '')
						return item;
					else if (item.username.indexOf(this.select_word) > -1) {
						return item;
					}

				});
			}
		}
	};
</script>


<style scoped>
	.colhead {
		padding-bottom: 2px;
		border-bottom: 1px solid #ccc;
		width: 100%;
	}
</style>
